export default class InfoActiveAccountHandler {
    constructor({isUserLoggedIn, isActivateAccount}) {
        this.isUserLoggedIn = isUserLoggedIn;
        this.isActivateAccount = isActivateAccount ? isActivateAccount : false;
        const searchParams = new URLSearchParams(window.location.search);
        this.openLoginModal = searchParams.has('login-modal') && !this.isUserLoggedIn && !searchParams.has('userExclusive');
        this.openRegisterModal = searchParams.has('register-modal') && !this.isUserLoggedIn && !searchParams.has('userExclusive');
        this.openRememberPasswordModal = searchParams.has('remember-password-modal') && !this.isUserLoggedIn && !searchParams.has('userExclusive');
        this.openChangePasswordModal = searchParams.has('change-password-modal') && !this.isUserLoggedIn;
        this.errorChangePasswordModal = searchParams.has('error-change-password-modal') && !this.isUserLoggedIn;
        this.eventDelegation();
    }

    eventDelegation() {
        if (document.querySelector('[data-attr="info-active-account"]') && this.isActivateAccount) {
            window.addEventListener('load', () => {
                myApp.customModalManager.openModal('#userModal');
                myApp.user.loginManager.openActiveUserModal();
            });
        } else if (document.querySelector('[data-attr="info-active-account-expired"]')) {
            window.addEventListener('load', () => {
                myApp.customModalManager.openModal('#userModal');
                myApp.user.loginManager.openRegisterModal();
            });
        }

        if (this.openLoginModal) {
            window.addEventListener('load', () => {
                myApp.customModalManager.openModal('#userModal');
                myApp.user.loginManager.openLoginModal();
            });
        }
        if (this.openRegisterModal) {
            window.addEventListener('load', () => {
                myApp.customModalManager.openModal('#userModal');
                myApp.user.loginManager.openRegisterModal();
            });
        }
        if (this.openRememberPasswordModal) {
            window.addEventListener('load', () => {
                myApp.customModalManager.openModal('#userModal');
                myApp.user.loginManager.openRememberPasswordModal();
            });
        }
        if (this.openChangePasswordModal || this.errorChangePasswordModal) {
            window.addEventListener('load',  () => {
                myApp.customModalManager.openModal('#userChangePasswordModal');
                if (this.errorChangePasswordModal) {
                    document.querySelector('#response-container-change-password-footer').style.display = 'none';
                    document.querySelector('#form-change-password').style.display = 'none';
                    const containerMessage = document.querySelector('[name="response-container-change-password"]');
                    containerMessage.classList.remove('hidden');
                }
            });
        }
    }
}
